import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { buyerApplicationResourceDefinition } from 'dpl/shared/utils/tptConnectResourceDefinitions';
import { getDayOfWeekOrDateString } from 'dpl/shared/utils/date';

function checkPuppyIdConstraint(
  currentPuppyId: number | string | null | undefined,
  applicationPuppyId: number | string | null
): boolean {
  // Breeder profile: hook omits `puppyId`, so we never compare listing ids
  if (currentPuppyId === undefined) {
    return true;
  }
  // Puppy profile: need puppy page listing id and an app tied to a listing
  if (currentPuppyId === null || applicationPuppyId === null) {
    return false;
  }
  return Number(applicationPuppyId) === Number(currentPuppyId);
}

export default function useBuyerApplicationSubmittedAt(
  breederProfileId: number | string,
  puppyId?: number | string | null
) {
  const { value, isFetching } = useResourceQuery({
    ...buyerApplicationResourceDefinition(Number(breederProfileId) as any),
    enabled: Boolean(Number(breederProfileId))
  });

  const submittedAt = value?.buyer_application?.submitted_at;
  const rejectedAt = value?.buyer_application?.rejected_at;
  const withdrawnAt = value?.buyer_application?.withdrawn_at;
  const applicationPuppyId = value?.buyer_application?.puppy_id ?? null;

  const shouldShowSuccessBanner = Boolean(
    !isFetching &&
      submittedAt &&
      !rejectedAt &&
      !withdrawnAt &&
      checkPuppyIdConstraint(puppyId, applicationPuppyId)
  );

  const submittedAtLabel = submittedAt
    ? getDayOfWeekOrDateString(new Date(submittedAt))
        .replace(/Today/g, 'today')
        .replace(/Yesterday/g, 'yesterday')
    : null;

  return {
    submittedAtLabel,
    hasSubmittedBuyerApplication: shouldShowSuccessBanner,
    isFetching
  };
}
